import React, { Component } from 'react';
import { connect } from 'react-redux';
import { find, filter, findIndex, every, capitalize } from 'lodash';
import { bindActionCreators } from 'redux';
import Modal from '../../../components/helpers/Modal';
import PictureHeader from '../../../components/admin/forms/PictureHeader';
import { MODELS, TEMP_ID_PREFIX, ALL_PAGESIZE } from '../../../constants/admin/settings';
import { formDataSelector, errorsSelector, dependenciesSelector } from '../../../selectors/admin/forms';
import { onInput, reset } from '../../../actions/admin/forms';
import Button from '../../../components/forms/Button';
import { createArtistWithContacts, fetchArtistUsers } from '../../../actions/admin/models/artists';
import ArtistContactForm from '../../../components/admin/forms/contacts/ArtistContactForm';
import HighlightRow from '../../../components/tables/HighlightRow';
import AdminTable from '../AdminTable';
import { selectedSelector } from '../../../selectors/admin/tables';
import { resetSelection } from '../../../actions/admin/tables';
import Loading from '../../../components/helpers/Loading';
import SelectField from '../../../components/forms/SelectField';
import { getHighestLevelArtistUsers } from '../../../selectors/admin/models/artists';
import {
    canChangeClearanceAccess,
    canChangePerformanceAccess,
    currentUserSelector
} from '../../../selectors/authentication';
import Checkbox from '../../../components/forms/Checkbox';

class PerformancesArtistForm extends Component {
    state = {
        showContactForm: false,
        showContactFields: false,
        submitting: false,
        fetchingContacts: false,
        fetchedContacts: false
    };

    componentDidUpdate(prevProps) {
        if (
            !prevProps.open &&
            this.props.open &&
            this.props.open !== true &&
            this.props.open.id &&
            !this.state.fetchingContacts &&
            !this.state.fetchedContacts
        ) {
            const { open, organizationId, contextId, eventId } = this.props;
            this.setState({ fetchingContacts: true });
            this._input(open.name, 'name');
            this._input(open.id, 'id');
            this.props.fetchArtistUsers(
                open.id,
                { page: 1, resultsPerPage: ALL_PAGESIZE },
                contextId,
                resp => {
                    this.setState({ fetchingContacts: false, fetchedContacts: true });
                    this.props.onInput(
                        MODELS.ARTIST_CONTACTS,
                        'list',
                        getHighestLevelArtistUsers(open.id, resp.users, organizationId, eventId, true)
                    );
                },
                true
            );
        }
    }

    _rolesOptions = () => {
        return (this.props.dependencies.roles || [])
            .filter(x => x.type === 'artist')
            .map(r => ({
                label: capitalize(r.role.replace(/_/g, ' ')),
                value: r.role
            }));
    };
    _changeInlineFunction = (id, value) => this._changeInlineMember(id, value, 'type');
    _changeInlineRole = (id, value) => this._changeInlineMember(id, value, 'permission');
    _changeInlineMember = (id, value, field) => {
        const index = findIndex(this.props.contactsData.list, x => x.id === id);
        this.props.onInput(
            MODELS.ARTIST_CONTACTS,
            'list',
            Object.assign([...this.props.contactsData.list], {
                [index]: { ...this.props.contactsData.list[index], [field]: value }
            })
        );
    };
    _changeInlineAccess = (id, value, type) => this._changeInlineMember(id, value, type);

    _transformFunctions = {
        type: (id, data) => {
            return (
                <SelectField
                    value={id}
                    error={!id}
                    onChange={v => {
                        this._changeInlineFunction(data.id, v);
                    }}
                    disabled={true}
                    items={[{ label: 'Artist', value: 'artist' }]}
                />
            );
        },
        permission: (id, data) => (
            <SelectField
                onChange={v => {
                    this._changeInlineRole(data.id, v);
                }}
                error={!id}
                value={id}
                items={this._rolesOptions()}
            />
        ),
        accessToPerformanceContracts: (id, data) => {
            return (
                <Checkbox
                    name={`accessToPerformanceContracts-${data.id}`}
                    onChange={v => {
                        this._changeInlineAccess(data.id, v.target.checked, 'accessToPerformanceContracts');
                    }}
                    className="u-margin-top-1-5"
                    disabled={!this._showPerformanceAccess()}
                    checked={data.accessToPerformanceContracts}
                />
            );
        },
        accessToClearanceContracts: (id, data) => {
            return (
                <Checkbox
                    name={`accessToClearanceContracts-${data.id}`}
                    onChange={v => {
                        this._changeInlineAccess(data.id, v.target.checked, 'accessToClearanceContracts');
                    }}
                    className="u-margin-top-1-5"
                    disabled={!this._showClearanceAccess()}
                    checked={data.accessToClearanceContracts}
                />
            );
        }
    };
    _input = (v, f) => this.props.onInput(MODELS.ARTIST, f, v);
    _inputContact = (v, f) => this.props.onInput(MODELS.ARTIST_CONTACTS, f, v);
    _clearInputContact = () => {
        ['id', 'email', 'fullName', 'permission'].forEach(x => this.props.onInput(MODELS.ARTIST_CONTACTS, x, ''));
        this.props.onInput(MODELS.ARTIST_CONTACTS, 'type', 'artist');
    };

    _close = () => {
        this.props.reset(MODELS.ARTIST);
        this.props.reset(MODELS.ARTIST_CONTACTS);

        this.props.onClose();
        this.setState({
            showContactForm: false,
            submitting: false,
            showContactFields: false,
            fetchingContacts: false,
            fetchedContacts: false
        });
    };
    _onSubmit = () => {
        this.setState({ submitting: true });
        this.props.createArtistWithContacts(
            this.props.data,
            this.props.contactsData.list,
            this._close,
            this._errorArtist
        );
    };
    _errorArtist = () => this.setState({ submitting: false });
    _showContactForm = () => this.setState({ showContactForm: true });
    _selectContact = v => {
        this.setState({ showContactFields: true });
        const user = find(this.props.dependencies.users || [], x => x.id === v);
        ['id', 'email', 'fullName', 'roles'].forEach(x => this.props.onInput(MODELS.ARTIST_CONTACTS, x, user[x]));
    };
    _newContact = () => {
        this.setState({ showContactFields: true });
        this._clearInputContact();
    };
    _cancelContact = () => {
        this.setState({ showContactFields: false, showContactForm: false });
        this._clearInputContact();
    };
    _submitContact = () => {
        const { contactsData } = this.props;
        this.setState({ showContactFields: false, showContactForm: false });
        this.props.onInput(MODELS.ARTIST_CONTACTS, 'list', [
            ...contactsData.list,
            {
                id: contactsData.id || `${TEMP_ID_PREFIX}${Date.now()}`,
                fullName: contactsData.fullName,
                type: contactsData.type,
                permission: contactsData.permission,
                email: contactsData.email,
                roles: contactsData.roles || [],
                accessToPerformanceContracts: contactsData.accessToPerformanceContracts,
                accessToClearanceContracts: contactsData.accessToClearanceContracts
            }
        ]);
        this._clearInputContact();
    };
    _removeContacts = () => {
        this.props.onInput(
            MODELS.ARTIST_CONTACTS,
            'list',
            filter(this.props.contactsData.list, c => !this.props.tableSelection.includes(c.id))
        );
        this.props.resetSelection();
    };

    _showPerformanceAccess = () => canChangePerformanceAccess(this.props.user, this.props.organizationId);
    _showClearanceAccess = () => canChangeClearanceAccess(this.props.user, this.props.organizationId);

    render() {
        const isNew = this.props.open === true || this.props.open === false;
        return (
            <Modal open={this.props.open} onClose={this._close} className="ckp-performances-artists is-huge">
                {this.state.submitting ? (
                    <Loading label="Saving artist & contacts..." />
                ) : (
                    <React.Fragment>
                        <PictureHeader
                            data={isNew ? this.props.data : this.props.open}
                            disabled={!isNew}
                            errors={this.props.errors}
                            nameLabel={'Artist Group Name *'}
                            onInput={this._input}
                            title={isNew ? 'Create new artist group' : 'Artist group'}
                        />
                        <div className="ckp-performances-artists-members">
                            <h3 className="ckp-ts-h1 u-margin-bottom-2">
                                {this.state.showContactForm ? 'Add artist contact' : 'Members'}
                            </h3>
                            {this.state.showContactForm ? (
                                <ArtistContactForm
                                    showPerformanceAccess={this._showPerformanceAccess()}
                                    showClearanceAccess={this._showClearanceAccess()}
                                    cancelContact={this._cancelContact}
                                    submitContact={this._submitContact}
                                    onInput={this._inputContact}
                                    showFields={this.state.showContactFields}
                                    newContact={this._newContact}
                                    selectContact={this._selectContact}
                                    contactOptions={this.props.dependencies.users || []}
                                    permissionOptions={this._rolesOptions()}
                                    data={this.props.contactsData}
                                />
                            ) : this.props.contactsData.list.length ? (
                                <AdminTable
                                    maxHeight
                                    transformFunctions={this._transformFunctions}
                                    buttonAction={this._showContactForm}
                                    skipDeleteConfirm={true}
                                    model={MODELS.ARTIST_CONTACTS}
                                    RowComponent={HighlightRow}
                                    actionBarClassName="is-transparent"
                                    canOpenRows={false}
                                    deleteAction={this._removeContacts}
                                    data={this.props.contactsData.list}
                                />
                            ) : (
                                <div className="ckp-performances-artists-members-empty">
                                    <h5 className="ckp-ts-h4 u-margin-bottom-3">
                                        {this.state.fetchingContacts
                                            ? 'Loading artist contacts...'
                                            : 'Nothing to show yet...'}
                                    </h5>
                                    {!this.state.fetchingContacts && (
                                        <Button label="Add artist contact" onClick={this._showContactForm} />
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="ckp-performances-artists-footer">
                            {Object.keys(this.props.errors).length ? (
                                <div className="ckp-performances-artists-errors">
                                    <p>Errors:</p>
                                    {Object.keys(this.props.errors).length ? (
                                        <p>{Object.values(this.props.errors).join(' ')}</p>
                                    ) : null}
                                </div>
                            ) : null}
                            <div className="ckp-performances-artists-buttons">
                                <Button className="is-sub is-small" label="Cancel" onClick={this._close} />
                                <Button
                                    inactive={
                                        this.state.showContactForm ||
                                        !this.props.data.name ||
                                        !every(this.props.contactsData.list, x => x.type && x.permission)
                                    }
                                    className="is-small"
                                    label="Save"
                                    onClick={this._onSubmit}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    errors: errorsSelector(state, { model: MODELS.ARTIST }),
    data: formDataSelector(state, { model: MODELS.ARTIST }),
    user: currentUserSelector(state),
    dependencies: dependenciesSelector(state),
    tableSelection: selectedSelector(state, {}),
    contactsData: formDataSelector(state, { model: MODELS.ARTIST_CONTACTS })
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ resetSelection, onInput, reset, fetchArtistUsers, createArtistWithContacts }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PerformancesArtistForm);
